/* eslint-disable */
export const routes = [
         {
           path: "/ristorazione/menu-composti",
           name: "RistorazioneMenuComposti",
           component: () =>
             import(
               /* webpackChunkName: "ristorazione_menu_composti" */ "../views/ristorazione/menuComposti"
             ),
         },
         {
           path: "/ristorazione/variazioni",
           name: "RistorazioneVariazioni",
           component: () =>
             import(
               /* webpackChunkName: "ristorazione_variazioni" */ "../views/ristorazione/variazioni"
             ),
         },
         {
           path: "/ristorazione/totem",
           name: "Totem",
           component: () =>
             import(
               /* webpackChunkName: "totem" */ "../views/ristorazione/totem"
             ),
         },
         // {
         //   path: "/ristorazione/ordina-prodotti-totem",
         //   name: "ordinaProdottiTotem",
         //   component: () =>
         //     import(
         //       /* webpackChunkName: "aggiungi_prodotto_totem" */ "../views/ristorazione/ordinaProdottiTotem"
         //     ),
         // },
         {
           path: "/ristorazione/alberatura-tag",
           name: "alberoTag",
           component: () =>
             import(
               /* webpackChunkName: "albero_tag" */ "../views/ristorazione/alberoTag"
             ),
         },
       ];
